import {useEffect, useState} from "react";
import {useFormContext} from "react-hook-form";
import {FiTrash} from "react-icons/fi";

import Button from "@/components/button/Button.tsx";
import {Divider} from "@/components/divider/Divider.tsx";
import {InputField} from "@/components/form/fields/InputField/InputField.tsx";
import {FormLabel} from "@/components/form/FormLabel.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {TimeInput} from "@/components/timeInput/TimeInput.tsx";

const minValidation = {
  value: 1,
  message: "should be more than 0",
};

const maxValidation = {
  value: 31,
  message: "should be less than 32",
};

interface MonthlyScheduleRowProps {
  id: string;
  name: string;
  index: number;
  remove: (index: number) => void;
}

export const MonthlyScheduleRow = ({id, name, index, remove}: MonthlyScheduleRowProps) => {
  const {setValue, watch, getValues, clearErrors} = useFormContext();
  const [monthdayFrom, monthdayTo] = getValues([`${name}.${index}.monthday_from`, `${name}.${index}.monthday_to`]);
  const [isSingleDay] = useState(monthdayFrom === monthdayTo);

  useEffect(() => {
    if (isSingleDay && monthdayFrom != null) {
      setValue(`${name}.${index}.monthday`, monthdayFrom);
    }
  }, [isSingleDay, monthdayFrom, setValue, name, index]);
  return (
    <div key={`monthly-${id}`}>
      <div className="row g-3">
        {isSingleDay && (
          <InputField
            className="col-12 col-md-5"
            name={`${name}.${index}.monthday`}
            label="Day"
            options={{
              min: minValidation,
              max: maxValidation,
              valueAsNumber: true,
            }}
          />
        )}
        {!isSingleDay && (
          <>
            <InputField
              className="col-12 col-md"
              name={`${name}.${index}.monthday_from`}
              label="Start Day"
              options={{
                min: minValidation,
                max: maxValidation,
                valueAsNumber: true,
                onChange: () => clearErrors([name]),
              }}
            />
            <InputField
              className="col-12 col-md"
              name={`${name}.${index}.monthday_to`}
              label="End Day"
              options={{
                min: minValidation,
                max: maxValidation,
                valueAsNumber: true,
                onChange: () => clearErrors([name]),
              }}
            />
          </>
        )}
        <div className="col-12 col-md-3">
          <FormLabel forId={`${name}.${index}.from_time`}>Start</FormLabel>
          <TimeInput
            name={`${name}.${index}.from_time`}
            defaultValue={"00:00"}
            value={watch(`${name}.${index}.from_time`)}
            onTimeChange={(val) =>
              setValue(`${name}.${index}.from_time`, val, {shouldDirty: true, shouldValidate: true})
            }
          />
        </div>
        <div className="col-12 col-md-3">
          <FormLabel forId={`${name}.${index}.to_time`}>End</FormLabel>
          <TimeInput
            name={`${name}.${index}.to_time`}
            defaultValue={"24:00"}
            value={watch(`${name}.${index}.to_time`)}
            onTimeChange={(val) => setValue(`${name}.${index}.to_time`, val, {shouldDirty: true, shouldValidate: true})}
          />
        </div>
        <div className="col-12 col-md-1 d-flex align-items-end justify-content-md-center">
          <Button
            variant="ghost"
            size="fitContent"
            onClick={() => {
              remove(index);
            }}
          >
            <Icon icon={FiTrash} className="m-md-2" />
            <span className="d-md-none d-inline-block">Remove Schedule</span>
          </Button>
        </div>
      </div>
      <div>
        <Divider className="my-3" />
      </div>
    </div>
  );
};
